"use strict";

exports.__esModule = true;
exports.default = void 0;
/* eslint-disable prefer-destructuring */

var breakpoints = ['576px', '768px', '992px', '1200px'];
breakpoints.default = '0px';
breakpoints.small = breakpoints[0]; // 576px

breakpoints.medium = breakpoints[1]; // 768px

breakpoints.large = breakpoints[2]; // 992px

breakpoints.xlarge = breakpoints[3]; // 1200px

var _default = breakpoints;
exports.default = _default;